export const SHOW_BAG_BANNER = "SHOW_BAG_BANNER";
export const BAG_BANNER_SHOWN = "BAG_BANNER_SHOWN";
